module.exports = __webpack_public_path__ + "media/images/topics/topics-ft-bg-4-7a2781eb27983cc8dea4d3b8ac55cf94.png";